/** Reasons returned when checkout is blocked for unpaid invoices. */
export enum CheckoutBlockReason {
  UNPAID_SPACE_USAGE = 'UNPAID_SPACE_USAGE',
  UNPAID_BALANCE_LIMIT_EXCEEDED = 'UNPAID_BALANCE_LIMIT_EXCEEDED'
}

/** Stable error codes for checkout eligibility. */
export enum CheckoutEligibilityErrorCode {
  CHECKOUT_BLOCKED_UNPAID_INVOICES = 'CHECKOUT_BLOCKED_UNPAID_INVOICES',
  CHECKOUT_BILLING_VERIFICATION_FAILED = 'CHECKOUT_BILLING_VERIFICATION_FAILED'
}

/** 409 payload when checkout is blocked due to unpaid invoices. */
export interface CheckoutBlockedError {
  err: string;
  error_code: CheckoutEligibilityErrorCode.CHECKOUT_BLOCKED_UNPAID_INVOICES;
  reasons: CheckoutBlockReason[];
  usageInvoiceIds: string[];
  outstandingInvoiceIds: string[];
  outstandingAmount: number;
  limitAmount: number;
  currency: string;
}

/** 503 payload when billing status could not be verified. */
export interface CheckoutVerificationFailedError {
  err: string;
  error_code: CheckoutEligibilityErrorCode.CHECKOUT_BILLING_VERIFICATION_FAILED;
  retryable: boolean;
}

export type CheckoutEligibilityError =
  | CheckoutBlockedError
  | CheckoutVerificationFailedError;

/** 200 payload when checkout is allowed. */
export interface CheckoutEligibilityAllowedResponse {
  allowed: true;
}
